import axios from "axios";
import {
  getLocalStorageItem,
  localStorageKeys,
  getPathnameLocalStorageItem,
} from "hooks";
import { refreshTokenHandler } from "./refreshTokenHandler";
// import { RefreshAccessToken, handleRefreshAuthtokens } from "queries/Auth";
// import { routes } from "routes/RouteConstants";

const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3000/",
  headers: {
    "content-type": "application/json",
    "x-api-key": process.env.REACT_APP_API_KEY || "web001122",
  },
});

const handleLogoutRedirectUser = () => {
  localStorage.removeItem(localStorageKeys.AUTH_TOKEN);
  localStorage.removeItem(localStorageKeys.REFRESH_TOKEN);
  localStorage.removeItem(localStorageKeys.USER_ROLE);
  window.location.href = "/";
};

AxiosInstance.interceptors.request.use(async (config) => {
  const authToken = await getLocalStorageItem(localStorageKeys.AUTH_TOKEN);
  if (authToken) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${authToken}`,
    };
  }
  if (config.language) {
    config.headers["language"] = config.language;
  }
  if (config && config.data && config.method === "get") {
    config.url = config.url + getPathnameLocalStorageItem();
    config.data = { ...config.data };
  }
  return config;
});

let isRefreshing = false;

AxiosInstance.interceptors.response.use(
  (response) => response.data,

  async (error) => {
    const originalRequest = error.config;

    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      if (isRefreshing) {
        return Promise.reject(error);
      }
      isRefreshing = true;
      try {
        const refreshToken = await getLocalStorageItem("REFRESH_TOKEN");
        const newData = await refreshTokenHandler(refreshToken);
        if (newData) {
          localStorage.clear();
          localStorage.setItem("AUTH_TOKEN", newData.data.tokens.accessToken);
          localStorage.setItem(
            "REFRESH_TOKEN",
            newData.data.tokens.refreshToken
          );
          // USER_ROLE must be restored here. localStorage.clear() above wipes it, and
          // every role gate in the app (Admin Portal tiles, Manage Employees, Points &
          // Rewards, the transaction forms) reads it. Losing it silently downgrades a
          // SUPER_ADMIN to no role at the first token refresh, even though the token
          // itself is valid and the APIs keep returning data.
          localStorage.setItem("USER_ROLE", newData.data.user.role);
          localStorage.setItem(
            "USER_DETAIL",
            JSON.stringify(newData.data.user)
          );
          isRefreshing = false;
          originalRequest.headers.Authorization = `Bearer ${newData.data.tokens.accessToken}`;
          return await AxiosInstance(originalRequest);
        }
      } catch (error) {
        isRefreshing = false;
        handleLogoutRedirectUser();
        return Promise.reject(error);
      }
    }

    if (
      error?.response?.status === 401 &&
      !(await getLocalStorageItem(localStorageKeys.AUTH_TOKEN))
    ) {
      handleLogoutRedirectUser();
    }

    return Promise.reject(error.response.data);
  }
);

export default AxiosInstance;
